<template>
  <div class="news-detail-page">
    <div class="news-hero">
      <img src="@/assets/images/新闻背景.jpg" alt="头图" />
      <div class="hero-text">
        <h1>品牌新闻<span class="en-title"> / NEWS CENTER</span></h1>
      </div>
    </div>

    <div class="news-detail-content">
      <h2>{{ pageTitle }}</h2>
      <p class="meta">2026-03-04 ｜ 👁 2839{{ $t('news.look') }}</p>

      <div v-if="isZh">
        <p>3月4日，中国时尚男装品牌CABBEEN卡宾携旗下年轻化街头品牌2AM，登陆吉隆坡升禧广场，开启为期五天的限时快闪体验，融合时尚、科技与文化。</p>
        <p>本次快闪以都市未来为核心概念。CABBEEN卡宾展区以巨型行李箱为创意造型，象征品牌从中国走向世界的出海之路；以明黄色为主视觉，打造活力先锋的沉浸式空间，展现品牌精湛剪裁、面料创新与兼具传统与先锋的美学表达。</p>
        <img src="@/assets/images/CABBEEN&2AM klcc/图片1.png" alt="CABBEEN x 2AM KLCC 现场图1" />
        <p class="image-caption">CABBEEN卡宾展区设计为一个巨型行李箱</p>
        <p>2AM展区则打造未来主义科技空间，聚焦科技鞋履设计，呈现4D打印技术与现代工业设计的融合，以环保与科技为基调，传递对未来穿搭的前沿探索。其4D打印运动鞋系列为亮点，采用360°透气晶格结构，兼具轻量化、耐用性与环保属性，AWAKE、ROCKER、EVOLVE、HYBRID 等鞋款凭借雕塑感建筑轮廓成为焦点。</p>
        <p>作为源自广州的中国品牌，卡宾此次以年轻化支线2AM作为出海先锋，向国际展现中国潮流品牌的创造力，诠释“中国质造”敢于不同、精益求精的内核。</p>
        <img src="@/assets/images/CABBEEN&2AM klcc/图片2.jpg" alt="CABBEEN x 2AM KLCC 现场图2" />
        <p class="image-caption">马来西亚当地歌手、达人</p>
        <p>活动首日，马来西亚主流媒体与时尚达人受邀预览，亲身感受这一剪裁与科技交汇、街头服饰进化为可穿戴创新的沉浸式概念空间。</p>
        <img src="@/assets/images/CABBEEN&2AM klcc/图片3.jpg" alt="CABBEEN x 2AM KLCC 现场图3" />
        <p class="image-caption">CABBEEN卡宾品牌创始人卡宾先生（杨紫明）</p>
        <p>面对马来西亚多元文化交融的市场特性，卡宾先生分享了其对“民族性”与“国际化”平衡之道的见解，CABBEEN卡宾的“根”扎得很深，这个“根”不仅是闽南的土地，更是中国人骨子里“爱拼会赢”的精气神。“好的设计就像好的音乐，无需翻译，直指人心。我们不从符号出发，而从精神入手。以真诚设计与文化表达打动全球年轻人。马来西亚是卡宾国际化首站，品牌将深耕当地市场，以吉隆坡为支点，辐射东盟。”</p>
      </div>

      <div v-else>
        <p>On March 4, Chinese menswear fashion brand CABBEEN, together with its youthful streetwear sub-label 2AM, landed at Starhill Gallery in Kuala Lumpur, launching a five-day limited-time pop-up experience that seamlessly integrates fashion, technology, and culture.</p>
        <p>This pop-up revolves around the concept of an “Urban Future.” The CABBEEN exhibition zone is designed in the form of a giant suitcase, symbolizing the brand’s journey from China to the global stage. Featuring a bold bright-yellow visual identity, the immersive space reflects the brand’s vitality and forward-thinking spirit, showcasing its refined tailoring, innovative fabrics, and a distinctive aesthetic that balances tradition with avant-garde expression.</p>
        <img src="@/assets/images/CABBEEN&2AM klcc/图片1.png" alt="CABBEEN x 2AM KLCC Event Image 1" />
        <p class="image-caption">The CABBEEN exhibition area is designed as a giant suitcase installation.</p>
        <p>The 2AM exhibition zone presents a futuristic technological space, focusing on innovative footwear design. It highlights the fusion of 4D printing technology with modern industrial design, emphasizing sustainability and technological advancement. The 4D-printed sneaker series stands out with its 360° breathable lattice structure, offering lightweight performance, durability, and eco-friendly attributes. Styles such as AWAKE, ROCKER, EVOLVE, and HYBRID draw attention with their sculptural, architectural silhouettes.</p>
        <p>As a Chinese brand originating from Guangzhou, CABBEEN positions its youthful sub-label 2AM as a pioneer in its global expansion, showcasing the creativity of Chinese streetwear to the international market and embodying the spirit of “Made in China” — bold, distinctive, and dedicated to excellence.</p>
        <img src="@/assets/images/CABBEEN&2AM klcc/图片2.jpg" alt="CABBEEN x 2AM KLCC Event Image 2" />
        <p class="image-caption">Local Malaysian singers and influencers were also present at the event.</p>
        <p>On the opening day, mainstream Malaysian media and fashion influencers were invited for an exclusive preview, experiencing firsthand this immersive concept space where tailoring meets technology and streetwear evolves into wearable innovation.</p>
        <img src="@/assets/images/CABBEEN&2AM klcc/图片3.jpg" alt="CABBEEN x 2AM KLCC Event Image 3" />
        <p class="image-caption">Mr. Cabbeen (Yang Ziming), Founder of CABBEEN.</p>
        <p>Addressing Malaysia’s culturally diverse market, Mr. Cabbeen shared his insights on balancing “cultural identity” and “globalization.” He emphasized that the brand’s “roots” run deep, not only in the land of Southern Fujian, but also in the resilient spirit of the Chinese people, embodied in the belief of “daring to strive and succeed.” “Great design is like great music, it needs no translation and speaks directly to the heart. We do not begin with symbols, but with spirit. Through sincere design and cultural expression, we aim to connect with young audiences worldwide.” Malaysia marks the first stop in CABBEEN’s international journey. The brand plans to establish a strong presence locally, using Kuala Lumpur as a strategic hub to expand across Southeast Asia.</p>
      </div>

      <div class="back">
        <router-link to="/news" class="back-button">
          <span class="arrow">←</span> 返回 / return
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'NewsCabbeen2AmKlcc',
  setup() {
    const { locale } = useI18n()
    const pageTitle = computed(() => (
      locale.value === 'zh'
        ? 'CABBEEN卡宾携2AM限时快闪登陆吉隆坡'
        : 'CABBEEN brings 2AM to Kuala Lumpur for a limited-time pop-up event.'
    ))
    const isZh = computed(() => locale.value === 'zh')
    return { pageTitle, isZh }
  },
}
</script>

<style scoped>
.news-detail-page {
  background: black;
  color: white;
  padding-bottom: 60px;
}

.news-hero {
  position: relative;
  height: 230px;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}

.news-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}

.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}

.hero-text h1 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  display: inline-block;
}

.en-title {
  display: inline;
  font-size: 20px;
  font-weight: normal;
  margin-left: 8px;
  letter-spacing: 0.5px;
  color: #ffb100;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.news-detail-content {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
}

.news-detail-content h2 {
  color: #ffb100;
  font-size: 26px;
  margin-bottom: 40px;
  text-align: center;
  padding: 0 20px;
}

.news-detail-content .meta {
  font-size: 13px;
  color: #aaa;
  margin-bottom: 20px;
  text-align: center;
}

.news-detail-content p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
  text-indent: 2em;
  font-size: 16px;
}

.news-detail-content .image-caption {
  margin-top: -4px;
  margin-bottom: 24px;
  text-align: center;
  text-indent: 0;
  color: #d0d0d0;
  font-size: 14px;
}

.news-detail-content img {
  width: 100%;
  margin: 20px 0;
  border-radius: 8px;
  display: block;
}

.back {
  margin-top: 40px;
  text-align: center;
}

.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  background-color: #000;
  color: #ffb100;
  border: 1px solid #ffb100;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.back-button:hover {
  background-color: #ffb100;
  color: #000;
  border-color: #000;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 179, 0, 0.2);
}

.back-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(255, 179, 0, 0.2);
}

.arrow {
  margin-right: 8px;
  font-size: 18px;
}

@media (max-width: 768px) {
  .news-hero {
    height: 180px;
  }

  .hero-text h1 {
    font-size: 18px;
  }

  .news-detail-content {
    max-width: 100%;
    margin: 20px 10px;
    padding: 0 10px;
  }

  .news-detail-content h2 {
    font-size: 22px;
  }

  .news-detail-content .meta {
    font-size: 12px;
  }

  .news-detail-content p {
    font-size: 14px;
  }

  .news-detail-content img {
    margin: 10px 0;
  }

  .back-button {
    padding: 8px 18px;
    font-size: 14px;
  }
}
</style>
